/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLogicNot = createReactComponent("outline", "logic-not", "IconLogicNot", [["path", { "d": "M22 12h-3", "key": "svg-0" }], ["path", { "d": "M2 9h3", "key": "svg-1" }], ["path", { "d": "M2 15h3", "key": "svg-2" }], ["path", { "d": "M5 5l10 7l-10 7z", "key": "svg-3" }], ["path", { "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }]]);

export { IconLogicNot as default };
//# sourceMappingURL=IconLogicNot.mjs.map
